module.exports = __webpack_public_path__ + "img/311.0a8eac9f.png";